// frontend/src/RequireAuth.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getToken } from './auth';

export default function RequireAuth({ children }) {
  const token = getToken();
  const location = useLocation();

  if (!token) {
    // Redirect to /login, but save the location we were at.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}